import { Page } from './../../../../../core/models/page';
export class ForwarderCooperationRequest extends Page{
  fromCountry?: string;
  fromCity?: string;
  toCountry?: string;
  toCity?: string;
  shippingType?: string;
  shipTerm?: string;
  searchAllMode?: boolean;

  constructor() {
    super();
    this.fromCountry = undefined;
    this.fromCity = undefined;
    this.toCountry = undefined;
    this.toCity = undefined;
    this.shippingType = undefined;
    this.shipTerm = undefined;
    this.pageIndex = undefined;
    this.pageSize = undefined;
    this.sortInfo = undefined;

  }
}
